module.exports = require("findup-sync");